import type { Dispatch } from 'react';
import { createContext } from 'react';
import type { IOrganizationAddCarePathState } from '../../../interfaces/organizationAddCarePathState';
import type { AddCarePathAction } from './organizationAddCarePathReducer';
import { AddCarePathSteps } from './constants/addCarePathSteps';

export const OrganizationAddCarePathContext = createContext<{
    addCarePathState: IOrganizationAddCarePathState;
    dispatchAddCarePathAction: Dispatch<AddCarePathAction>;
}>({
    addCarePathState: {
        currentStep: AddCarePathSteps.chooseCarePath,
        organizationId: '',
    },
    dispatchAddCarePathAction: () => null,
});
